(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-menu"] && !Shopify.designMode) return;
  try {
    // Handle Shop By Make brand hover to show categories
  document.addEventListener('DOMContentLoaded', () => {
    const makeWrappers = document.querySelectorAll('.simple-dropdown__make-wrapper');
    
    makeWrappers.forEach(wrapper => {
      const brandItems = wrapper.querySelectorAll('.simple-dropdown__make-item');
      const categoryMenus = wrapper.querySelectorAll('.simple-dropdown__category-submenu');
      
      brandItems.forEach((item, index) => {
        item.addEventListener('mouseenter', () => {
          // Remove active state from all items
          brandItems.forEach(b => b.classList.remove('active'));
          // Hide all category menus
          categoryMenus.forEach(m => m.style.display = 'none');
          
          // Add active state to hovered item
          item.classList.add('active');
          // Show corresponding category menu
          const matchingMenu = wrapper.querySelector(`.simple-dropdown__category-submenu[data-brand-index="${index}"]`);
          if (matchingMenu) {
            matchingMenu.style.display = 'block';
          }
        });
      });
      
      // Optional: Hide all on mouseleave from the grid
      const grid = wrapper.querySelector('.simple-dropdown__make-grid');
      if (grid) {
        grid.addEventListener('mouseleave', () => {
          brandItems.forEach(b => b.classList.remove('active'));
          categoryMenus.forEach(m => m.style.display = 'none');
        });
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["complementary-products"] && !Shopify.designMode) return;
  try {
    (function() {
    function initComplementaryProducts() {
      const buttons = document.querySelectorAll('.complementary-product-item__add-to-cart');
      
      buttons.forEach(button => {
        // Remove any existing listeners
        button.replaceWith(button.cloneNode(true));
      });
      
      // Re-query after cloning
      const freshButtons = document.querySelectorAll('.complementary-product-item__add-to-cart');
      
      freshButtons.forEach(button => {
        button.addEventListener('click', async function(event) {
          event.preventDefault();
          
          const variantId = this.dataset.variantId;
          
          if (!variantId || this.disabled) return;

          const originalText = this.textContent;
          this.classList.add('loading');
          this.textContent = 'Adding...';
          this.disabled = true;

          try {
            const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify({
                items: [{
                  id: variantId,
                  quantity: 1
                }]
              })
            });

            if (!response.ok) {
              const errorData = await response.json();
              throw new Error(errorData.description || 'Failed to add to cart');
            }

            const data = await response.json();
            
            // Success feedback
            this.textContent = 'Added!';
            this.classList.remove('loading');
            
            // Trigger cart refresh/update
            if (window.theme && typeof window.theme.cart !== 'undefined') {
              window.theme.cart.refresh();
            }
            
            // Dispatch custom event for cart updates
            document.dispatchEvent(new CustomEvent('cart:updated', { 
              detail: { cart: data }
            }));
            
            // Trigger Shopify theme event if available
            if (typeof Shopify !== 'undefined' && Shopify.theme && Shopify.theme.cart) {
              Shopify.theme.cart.getCart();
            }

            // Reset button after 2 seconds
            setTimeout(() => {
              this.textContent = originalText;
              this.disabled = false;
            }, 2000);

          } catch (error) {
            console.error('Error adding to cart:', error);
            this.textContent = 'Error';
            this.classList.remove('loading');
            
            setTimeout(() => {
              this.textContent = originalText;
              this.disabled = false;
            }, 2000);
          }
        });
      });
    }

    // Initialize on load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initComplementaryProducts);
    } else {
      initComplementaryProducts();
    }
    
    // Re-initialize on Shopify section load (for theme editor)
    document.addEventListener('shopify:section:load', initComplementaryProducts);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["fitment_data-tabs"] && !Shopify.designMode) return;
  try {
    (function() {
    document.querySelectorAll('.fitment-tabs').forEach(function(container) {
      var buttons = container.querySelectorAll('[data-fitment-tab]');
      var panels = container.querySelectorAll('[data-fitment-panel]');

      buttons.forEach(function(btn) {
        btn.addEventListener('click', function() {
          var target = btn.getAttribute('data-fitment-tab');

          buttons.forEach(function(b) {
            b.classList.remove('fitment-tabs__btn--active');
            b.setAttribute('aria-selected', 'false');
          });

          panels.forEach(function(p) {
            p.classList.remove('fitment-tabs__panel--active');
          });

          btn.classList.add('fitment-tabs__btn--active');
          btn.setAttribute('aria-selected', 'true');

          var activePanel = container.querySelector('[data-fitment-panel="' + target + '"]');
          if (activePanel) {
            activePanel.classList.add('fitment-tabs__panel--active');
          }
        });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
